import React, { ComponentProps, FC, memo } from 'react'

import { Button as RoovStandardButton } from '@style-port/roov-ui-components-react'
import { ButtonInner, ButtonInnerProps } from 'src/components/atoms/inputs/ButtonInner'

type ButtonProps = ComponentProps<'button'>
type Props = Omit<ButtonInnerProps, 'buttonType'> & {
  buttonType?: 'primary' | 'secondary' | 'tertiary' | 'danger'
  isLoading?: boolean
} & ButtonProps

export const StandardButton: FC<Props> = memo(
  ({
    buttonType = 'primary',
    size = 'm',
    children,
    text,
    prependIconPath,
    appendIconPath,
    isLoading = false,
    disabled,
    ...otherProps
  }) => {
    return (
      <RoovStandardButton
        buttonType={buttonType}
        size={size}
        disabled={isLoading || disabled}
        {...otherProps}
      >
        <ButtonInner
          buttonType={buttonType}
          size={size}
          text={text}
          prependIconPath={prependIconPath}
          appendIconPath={appendIconPath}
          isLoading={isLoading}
          disabled={disabled}
        >
          {children ?? null}
        </ButtonInner>
      </RoovStandardButton>
    )
  }
)
